<template>
  <v-card>
    <!-- App Bar -->
    <v-app-bar color="white" prominent class="mb-n16 appbar-nav">

      <router-link to="/" class="d-flex align-center">
        
       <!--  <img 
          :src="require('../assets/simulart.svg')"
          alt="Logo" 
          style="height: 40px; cursor: pointer; margin: 0 20px; color:black;"  
        /> -->
      </router-link>

      <v-toolbar-title class="azul  titulo-nav" >
      <router-link to="/" style="color:#0076A0 !important; text-decoration: none;">
        {{$t('login.titulo')}}
     <span class="subtitle gris_medio d-flex align-center">By<!--  <img 
        class="ml-1 mr-1"
          :src="require('../assets/simulart.svg')"
          alt="Logo" 
          style="height: 15px; cursor: pointer;color:black;" 
        /> --> SimularT & Viscofan España
        
      </span>
      </router-link>
      
      </v-toolbar-title>
      
      
<v-spacer class="appbar-spacer" />
     
      
      <v-btn  class="gris_medio tab-hover-azul subrayado nav-btn"  to="/simulaciones"> 
        {{$t('home.inicio')}}
      </v-btn>
      <v-menu >
        <template v-slot:activator="{ props }">
        <v-btn
          v-bind="props"
          
          
          
          class="v-tab--active v-tab_sim subrayado nav-btn"
         
        >
            {{$t('home.simulaciones')}}
            <v-icon icon="mdi-menu-down" end></v-icon>
          </v-btn>
        </template>

        <v-list class="gris_medio ">
          <v-list-item class="tab-hover-azul" to="/nueva-simulacion">
             {{$t('home.nueva_sim')}}
          </v-list-item>
          <v-list-item class="tab-hover-azul" to="/simulaciones">
            {{$t('home.historico_sim')}}
          </v-list-item>
        </v-list>
      </v-menu>

      <v-menu v-if="!vista_operador">
        <template v-slot:activator="{ props }">
        <v-btn
          v-bind="props"
          
          
         
          class="v-tab--active gris_medio tab-hover-azul subrayado nav-btn"
         
        >
            <v-icon left>mdi-currency-eur</v-icon> {{$t('home.descargadores')}}
            <v-icon icon="mdi-menu-down" end></v-icon>
          </v-btn>
        </template>

        <v-list class="gris_medio">
          <v-list-item class="tab-hover-azul" to="/precios">
            <v-icon left>mdi-chart-line</v-icon> {{$t('home.precios')}}
          </v-list-item>
          <v-list-item class="tab-hover-azul" to="/futuros">
            <v-icon left>mdi-finance</v-icon> {{$t('home.futuro')}}
          </v-list-item>
        </v-list>
      </v-menu>


      <v-menu v-if="!vista_operador">
        <template v-slot:activator="{ props }">
        <v-btn
          v-bind="props"
          
          
         
          class="v-tab--active gris_medio tab-hover-azul subrayado nav-btn"
         
        >
            <v-icon left>mdi-table</v-icon> {{$t('home.maestros')}}
            <v-icon icon="mdi-menu-down" end></v-icon>
          </v-btn>
        </template>

        <v-list class="gris_medio">
          <v-list-item class="tab-hover-azul" to="/ro">
            <v-icon left>mdi-chart-line</v-icon> {{$t('home.ro')}}
          </v-list-item>
          
        </v-list>
      </v-menu>




      <v-btn v-if="!vista_operador" class="gris_medio tab-hover-azul subrayado nav-btn" to="/informes">
        
           <v-icon left>mdi-file-chart-outline</v-icon> {{$t('home.informes')}}
      
       
      </v-btn>

      <!-- <span class="userManual">Manual de usuario</span> -->
      <v-btn icon @click="dialog = true" class="gris_medio tab-hover-azul subrayado nav-btn">
          <v-icon>mdi-book-open-variant</v-icon>
        </v-btn>

        <v-dialog v-model="dialog" max-width="1200">
          <v-card>
            <v-card-title>
             Manual de usuario
            </v-card-title>
            
            <!-- <v-card-title>Manual de usuario</v-card-title> -->
            <v-card-text class="gris_medio">              
                  <ComponenteDoc/>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="dialog = false">Cerrar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>      

      <template v-if="$vuetify.display.mdAndUp" >
        <div class="gris_suave  usuario-nav" > {{ usuario }}</div>        
      </template>

      <!-- Contenedor para idioma e ícono de salida -->
      <div class="d-flex align-center">
        <!-- Selector de idioma -->
        <ComponenteIdioma class="mr-3" />

        <!-- Icono de salir -->
        <router-link to="/login" class="nav-link">
          <v-btn class="gris_medio" icon="mdi-exit-to-app" variant="text"></v-btn>
        </router-link>
      </div>
    </v-app-bar>


    <!-- Contenido Principal -->
    <v-main class="mt-n16 " style="min-height: 100vh; height: auto;">
      <div v-if="isRouterViewEmpty">       
      <!--  <img :src="require('../assets/logo-viscosim.png')" alt="Empty State" class="empty-state-image" style="opacity: 0.1;"/>-->
      </div>      
      <router-view></router-view>
    </v-main>
  </v-card>
</template>

<script>
  import store from '../store';
  import ComponenteIdioma from './ComponenteIdioma.vue';
  import ComponenteDoc from './ComponenteDoc.vue';

  export default {
    data: () => ({
      dialog: false,
      usuario: store.state.usuarioNombre,
      vista_operador: false,
      drawer: false,
      group: null,
      items: [
        {
          title: 'Foo',
          value: 'foo',
        },
        {
          title: 'Bar',
          value: 'bar',
        },
        {
          title: 'Fizz',
          value: 'fizz',
        },
        {
          title: 'Buzz',
          value: 'buzz',
        },
      ],
    }),

    components: {
      ComponenteIdioma,
      ComponenteDoc,
    },


    watch: {
      group () {
        this.drawer = false
      },
    },


    computed: {
    isRouterViewEmpty() {
      // Determina si el router-view está vacío

      console.log("nombre:")
      console.log(this.$route.name)
      console.log(!this.$route.name)

      if (this.$route.name == 'PaginaHome') {
          return true
      } else {
          return false
      }

      
      }
    },

    created(){
      // Cargar configuración proporcionada desde `main.js`
      fetch('/config.json')
        .then((response) => response.json())
        .then((config) => {
          this.mostrar_boton_descargar_in = config.mostrar_boton_descargar_in;  
          this.usuarios_operadores = config.usuarios_operadores;
          
          
          
          if (this.usuarios_operadores.includes(this.usuario)) {
              this.vista_operador = true;
          } else {
              this.vista_operador = false;
          }
          
                  
        })
        .catch((error) => {
          console.error('Error al cargar la configuración:', error);
          
        });
    },


  }
</script>


<style scoped>
.nav-link {
  text-decoration: none;
  color: inherit; /* Heredar el color del texto padre */
  display: flex;
  align-items: center; /* Alinear ícono y texto verticalmente */
}

.nav-icon {
  margin-right: 8px; /* Espacio entre el ícono y el texto */
}

.empty-state {
  justify-content: center;
  align-items: center;
}

.empty-state-image {
  /* Estilos para tu imagen */
  width: 70%;
  height: auto;
  display: block;
  max-width: 100%; /* Ajusta este valor según sea necesario */
  margin: 0 auto;
  margin-top: 10px;
}

.userManual{
  font-size: 14px;
}
.v-main {
  min-height: 100vh !important;
  height: auto !important;
}
.appbar-nav :deep(.v-toolbar__content) {
  gap: 12px;                 /* separación horizontal entre botones */
  align-items: stretch;      /* permite que los hijos se estiren */
}

/* Los botones ocupan todo el alto de la barra */
.appbar-nav :deep(.v-btn.nav-btn) {
  align-self: stretch;       /* estira cada botón en vertical */
  height: auto;              /* deja que herede el alto de la barra */
  border-radius: 0;          /* borde recto como en tu mock */
  padding-inline: 16px;      /* un poco de “aire” lateral */
}

/* En pantallas táctiles, separación algo menor si quieres */
@media (pointer: coarse) {
  .appbar-nav :deep(.v-toolbar__content) { gap: 8px; }
}

.titulo-nav {
  display: flex;
  flex-direction: column;
  justify-content: center;  /* Centra verticalmente el texto y el subtítulo */
}

.usuario-nav {
  display: flex;
  align-items: center; /* Centra verticalmente el nombre de usuario */
  height: 100%;        /* Ocupar toda la altura de la app-bar */
}
/* Deja todo en una línea, pero permite que el spacer empuje a la derecha */
.appbar-nav .v-toolbar__content > * { flex: 0 0 auto; }
.appbar-nav .v-toolbar__content > .v-spacer,
.appbar-nav .v-toolbar__content > .appbar-spacer {
  flex: 1 1 auto !important;
}
</style>